export const Browser = {
    isTouchDevice: hasTouch(),

    isOnePage: document.body.classList.contains('onepager'),

    scrollbarWidth: getScrollbarWidth(),
};

function hasTouch() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
}
